import { Component, OnInit, OnDestroy, ChangeDetectionStrategy, ChangeDetectorRef, ViewEncapsulation, inject } from "@angular/core";
import { ResponseErrorHandlerService } from "../shared";
import { Subscription } from "rxjs";
import { componentApi } from "@wk/components-v3-angular17";

@Component({
    selector: "notify-popup",
    changeDetection: ChangeDetectionStrategy.OnPush,
    host: { class: "cg3-host-notification-story1" },
    templateUrl: "./notify-popup.component.html",
    encapsulation: ViewEncapsulation.None,
    standalone: false,
})
export class NotifyPopupComponent implements OnInit, OnDestroy {
    private responseErrorHandlerService = inject(ResponseErrorHandlerService);
    public changeDetector = inject(ChangeDetectorRef);

    model: any;
    showPopupEvent: Subscription;

    writeState = componentApi.writeState.bind(this);
    notifications: {
        id?: number;
        autoCloseTimeout?: number;
        messageCode: string;
        isOpen: boolean;
    }[];

    autoCloseTimeout: number;
    hasCloseButton: boolean;

    constructor() {
        this.model = {};
        this.notifications = [];
        this.autoCloseTimeout = null;
        this.hasCloseButton = true;
        this.showPopupEvent = this.responseErrorHandlerService.showPopupEvent$.subscribe((message) => {
            if (!message.isShowed && message.messageCode) {
                const newState = this.notifications;
                const index = newState.findIndex((item) => item.messageCode === message.messageCode);
                if (index !== -1) {
                    newState[index].isOpen = false;
                    this.writeState("notifications", [...newState]);
                }
            } else {
                this.model = message;

                const newState = this.notifications.find((item) => item.isOpen) ? this.notifications : [];
                if (newState.length === 0) {
                    const i = newState.length;
                    this.writeState("notifications", [
                        ...newState,
                        {
                            id: i,
                            messageCode: message.messageCode,
                            isOpen: true,
                            autoCloseTimeout: this.autoCloseTimeout,
                        },
                    ]);
                }
            }
        });
    }

    ngOnInit() {
        //purposely left empty.
    }
    ngOnDestroy() {
        this.showPopupEvent.unsubscribe();
    }

    setClass() {
        return {
            active: this.model.isShowed,
            hidden_cards_wraper: this.model.messageCode === "hiddenCards" || this.model.messageCode === "hiddenJobsCards",
        };
    }

    handleUserRequest(value: any, id: any) {
        const newState = this.notifications;
        const index = newState.findIndex((item) => item.id === id);
        newState[index].isOpen = value;
        this.writeState("notifications", [...newState]);
    }
}
